import useChartDataFromResource, {
  percentageFormatter,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/useChartDataFromResource';

const PERFORMANCE_ATTR = 'accountPerformanceChartData';
const BENCHMARK_ATTR = 'benchmarkPerformanceChartData';

export default function useAccountPerformance(resource) {
  const {
    chartData,
    xAxisArgs,
    yAxisArgs,
  } = useChartDataFromResource({
    resource,
    dataAttributes: [
      { name: PERFORMANCE_ATTR, xAttr: 'date', yAttr: 'percentageValue' },
      { name: BENCHMARK_ATTR, xAttr: 'date', yAttr: 'percentageValue' },
    ],
    yAxisTickFormatter: percentageFormatter,
  });

  const performanceData = chartData[PERFORMANCE_ATTR];
  const benchmarkData = chartData[BENCHMARK_ATTR];

  return {
    performanceData,
    benchmarkData,
    xAxisArgs,
    yAxisArgs,
  };
}
